import { getVisitData } from "./getVisitData";

export function getCoreAttributes({
  geoCountry,
  browseCountry,
  browseLanguage: language,
  storeId: browseStore,
  platform,
  floor
}) {
  const { notBouncedVisit, visitPageCount } = getVisitData();

  return {
    geoCountry,
    browseCountry,
    language,
    browseStore,
    platform,
    floor,
    ...(typeof visitPageCount === "number" ? { visitPageCount } : {}),
    ...(notBouncedVisit === true ? { notBouncedVisit } : {})
  };
}
